import React from 'react';
import { Link } from 'react-router-dom';

import styles from './BackLink.module.scss';

interface Props {
  textColour?: string;
  title?: string;
}

const BackLink: React.FC<Props> = ({ textColour = 'kale', title = 'Back to menus' }) => {
  const segments = window.location.pathname.split('/').filter(Boolean);
  const backUrl = `/${segments[0]}/${segments[1]}`;

  return (
    <Link className={`${styles.BackLink} ${styles[textColour]}`} to={backUrl} data-testid="back-link">
      <i className="mm-angle-left" />
      <span>{title}</span>
    </Link>
  );
};

export default BackLink;
